module.exports = __webpack_public_path__ + "static/media/pancake-logo.bdd7c45a.png";